var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pusher-rtc-container",attrs:{"id":"room-container"}},[_c('comp-stream-pusher',{staticClass:"stream-pusher"}),_c('comp-stream-control',{staticClass:"stream-control"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }